"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DialogFooter = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
/**
 * A wrapper for `Dialog` footer content
 * (content will automatically be wrapped when using the `footer` prop).
 *
 * @related [`Dialog`]
 * @since 7.0.0
 */
var DialogFooter = /*#__PURE__*/_styledComponents.default.footer.withConfig({
  displayName: "DialogFooter",
  componentId: "c11n-8-107-0__sc-3beuip-0"
})([""]);
exports.DialogFooter = DialogFooter;
DialogFooter.displayName = 'DialogFooter';

/** @component */